import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { settingManageChange } from 'services/setting'
import posthog from 'posthog-js'

export default function useSetManageSetting(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISettingManagePayload) => {
            return settingManageChange(payload)
        },
        onSuccess: (data, variables) => {
            posthog.capture('fund_setting_account_saved', {
                fund_id: variables.id,
                gateway_type: variables.type,
                trust_state: variables.trustState,
            })
            toast.success('مشخصات صندوق با موفقیت تغییر یافت')
            refetch()
        },
        onError: (error: any, variables) => {
            posthog.capture('fund_setting_save_failed', {
                section: 'account',
                fund_id: variables?.id,
                status: error?.response?.status,
            })
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { isLoading, mutate }
}
